import { User } from "oidc-client-ts";

export interface userInfoForSupportTicketTypes {
  givenName: string;
  familyName: string;
  email: string;
  namespace: string;
}

export class UserInfoSupportTicketExtractor {
  private namespace: string;

  constructor(namespace: string) {
    this.namespace = namespace;
  }

  public extractUserInfo(user: User): userInfoForSupportTicketTypes {
    let givenName = "";
    let familyName = "";
    let email = "";
    const namespace = this.namespace;

    if (user && user.profile) {
      givenName = user.profile.given_name || "";
      familyName = user.profile.family_name || "";
      email = user.profile.email || "";
    }

    return { givenName, familyName, email, namespace };
  }
}
